<template>
  <transition name="slide-notification-items">
    <div class="notification-items" v-if="shouldDisplayNotifications">
      <div class="notification-items__container">
        <transition-group name="slide-notification" tag="div">
          <template v-for="notification in notificationsToDisplay" :key="notification.index">
            <notification-item-simple
              :autoClose="true"
              :text="notification.data.text"
              :icon="notification.data.icon"
              :title="notification.data.title"
              :closeTimeout="notification.data.closeTimeout"
              :index="notification.index"
              v-if="shouldDisplayNotificationSimple(notification)"
            >
            </notification-item-simple>
            <notification-item-trade-confirmed
              :autoClose="true"
              :closeTimeout="NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY"
              :index="notification.index"
              :data="notification.data"
              v-if="shouldDisplayNotificationTradeConfirmed(notification)"
            >
            </notification-item-trade-confirmed>
            <notification-item-dashboard
              :autoClose="true"
              :closeButton="true"
              :closeTimeout="NOTIFICATION_SHARES_TRADED_CLOSE_DELAY"
              theme="notifications"
              :index="notification.index"
              :data="notification.data"
              v-if="shouldDisplayDashboardNotification(notification)"
            >
            </notification-item-dashboard>
          </template>
        </transition-group>
      </div>
    </div>
  </transition>
</template>

<script src="./notification-items.js"></script>
<style src="./notification-items.scss" lang="scss"></style>
